import CONNECTION_TYPE from '../../common/connection-type';

/** Connection types that assign prescriptions from order_staging (legacy + partner integrations). */
export const usesOrderStagingAssignFlow = (connectionId) =>
  connectionId === CONNECTION_TYPE.MSCRIPTS ||
  connectionId === CONNECTION_TYPE.SOLIS;

/** Connection types that use the generic integration-assign lookup API (not legacy MScripts routes). */
export const usesIntegrationAssignLookup = (connectionId) =>
  connectionId === CONNECTION_TYPE.SOLIS;

export const PARTNER_INTEGRATION_ASSIGN_PHI_TYPE = 'PartnerIntegration';

export const resolveAssignConnectionTypeId = (component) => {
  const { globalAccountConnection, accountDetails } = component.state || {};
  return (
    (globalAccountConnection && globalAccountConnection.account_connections_id) ||
    (globalAccountConnection &&
      globalAccountConnection.connection &&
      globalAccountConnection.connection.id) ||
    (accountDetails && accountDetails.connection && accountDetails.connection.id) ||
    (accountDetails && accountDetails.account_connections_id) ||
    null
  );
};

export const resolveAssignAccountId = (component) => {
  const { globalAccountConnection, accountDetails } = component.state || {};
  return (
    (globalAccountConnection && globalAccountConnection.id) ||
    (accountDetails && accountDetails.id) ||
    null
  );
};



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/integration-assign/orderStagingAssignHelpers.js